<template>
<div>
	<div id="dockBar" > <!--Dock-bar component begin-->
	<div class="wraper">
		<div class="icon " v-bind:class="{tabActive: activeTab == 'main'}" id="mainIcon" @click="activeTab = 'main'; changeTab()">
<svg xmlns="http://www.w3.org/2000/svg" style="width:40px; height:40px" viewBox="0 0 790.75 743.11"><path d="M654.63 743.1H469.45c-13.807 0-25-11.193-25-25V498.5H346.3V718.1c0 13.807-11.193 25-25 25H136.1c-13.807 0-25-11.193-25-25V416.94H25.03a25 25 0 0 1-17.6-42.76L377.78 7.24c9.744-9.653 25.446-9.653 35.2 0l370.37 366.94a25 25 0 0 1-17.6 42.76h-86.1V718.1c0 13.807-11.193 25-25 25zm-160.18-50h135.18V391.94c0-13.807 11.193-25 25-25h50.4L395.37 60.2 85.75 366.94h50.36c13.807 0 25 11.193 25 25V693.1h135.2V473.5c0-13.807 11.193-25 25-25h148.15c13.807 0 25 11.193 25 25z" fill="#none"/></svg>
		</div>
		<div class="icon" v-bind:class="{tabActive: activeTab == 'plan'}" @click="activeTab = 'plan'; changeTab()" >
<svg xmlns="http://www.w3.org/2000/svg" style="width:40px; height:40px" viewBox="0 0 592.97 798.13"><path fill="" d="M296.5 798.13h-.1a25 25 0 0 1-21.09-11.72l-71.45-114a25 25 0 0 1-3.24-18.62l71.45-327c2.506-11.463 12.647-19.64 24.38-19.66 11.72-.002 21.87 8.138 24.4 19.58l72.55 327a25 25 0 0 1-3.32 18.84l-72.55 114a25 25 0 0 1-21.05 11.58zM251.64 654.5l45 71.8 45.74-71.87-45.7-206z"/><path fill="#none" d="M567.98 684.13H369.04c-13.807 0-25-11.193-25-25s11.193-25 25-25h161L296.5 88.52 62.9 634.13h162.14c13.807 0 25 11.193 25 25s-11.193 25-25 25h-200a25 25 0 0 1-23-34.84L273.5 15.13a25 25 0 0 1 46 0L590.96 649.3a25 25 0 0 1-23 34.84z"/></svg>
			<!--<p>Літачок</p>-->
		</div>
		<!--<div class="icon" v-bind:class="{tabActive: activeTab == 'calc'}" @click="activeTab = 'calc'; changeTab()">
			<svg xmlns="http://www.w3.org/2000/svg" style="width:50px; height:50px" width="24" height="24" viewBox="0 0 24 24"><path fill="none" d="M0 0h24v24H0V0z"/><path d="M7,2H17A2,2 0 0,1 19,4V20A2,2 0 0,1 17,22H7A2,2 0 0,1 5,20V4A2,2 0 0,1 7,2M7,4V8H17V4H7M7,10V12H9V10H7M11,10V12H13V10H11M15,10V12H17V10H15M7,14V16H9V14H7M11,14V16H13V14H11M15,14V16H17V14H15M7,18V20H9V18H7M11,18V20H13V18H11M15,18V20H17V18H15Z"/></svg>			
			<p>Калькулятори</p>
		</div>-->
<!-- 
		<div class="icon" v-bind:class="{tabActive: activeTab == 'info'}" @click="activeTab = 'info'; changeTab()" >
<svg xmlns="http://www.w3.org/2000/svg" style="width:40px; height:40px" viewBox="0 0 661.58 661.58" ><path fill="#none" d="M330.8 661.6C161.412 661.378 19.728 532.905 2.988 364.356s96.91-322.38 262.937-355.9 330.46 64.16 380.43 226-30.77 335.22-186.795 401.145a328.68 328.68 0 0 1-128.77 26zm0-611.6C175.96 50 50 176 50 330.8s125.96 280.8 280.8 280.8 280.8-126 280.8-280.8S485.62 50 330.8 50zm1.36 507.37c-13.807 0-25-11.193-25-25l-.37-301.88c0-13.807 11.193-25 25-25s25 11.193 25 25l.38 301.92c0 13.807-11.193 25-25 25z"/><circle fill="#none" cx="330.78" cy="139.23" r="25.24"/></svg> -->

		<div class="icon" v-bind:class="{tabActive: activeTab == 'info'}" @click="activeTab = 'info'; changeTab()" >
<svg xmlns="http://www.w3.org/2000/svg" style="width:40px; height:40px" viewBox="0 0 661.6 661.6"><path d="M330.8 661.6C161.4 661.4 19.7 532.9 3 364.4S99.9 42 265.9 8.5s330.5 64.2 380.4 226-30.8 335.2-186.8 401.1c-40.7 17.2-84.5 26.1-128.7 26zm0-611.6C176 50 50 176 50 330.8s126 280.8 280.8 280.8 280.8-126 280.8-280.8S485.6 50 330.8 50z"/><circle cx="328.6" cy="179.2" r="25"/><path d="M328.5 505.4c-13.8 0-25-11.2-25-25V270.7c0-13.8 11.2-25 25-25s25 11.2 25 25v209.8c0 13.7-11.1 24.9-25 24.9z"/></svg>
			<!--<p>Про додаток</p>-->
		</div>
	</div>
	</div> <!--Dock-bar component end-->
</div>
</template>

<script>
export default {
	data () {
		return {
			activeTab: 'main'
				}
			},
	methods: {
		changeTab: function() {
		this.$emit('tabChanged', this.activeTab)
			}
		}
		}
</script>

<style scoped>
#dockBar {
		height: 65px;
		display: flex;
		position: fixed;
		bottom: 0;
		right: 0;
		left: 0;
		width: 100vw;
		background-color: #fdfdfd; 
		box-shadow: 0px 2px 8px 0px rgba(0, 0, 0, 0.13);
		opacity: 0.96;
		border-top: solid 1px rgba(0, 0, 0, 0.13);
}
div.wraper {
	display: flex;
	-webkit-flex-direction: row;
	-moz-flex-direction: row;
	-ms-flex-direction: row;
	-o-flex-direction: row;
	flex-direction: row;
	margin: auto;
	align-items: center;
	margin-top: 0px;
	margin-bottom: 0px;
}
.icon {
	display: -webkit-flex;
	display: -moz-flex;
	display: -ms-flex;
	display: -o-flex;
	display: flex;
	justify-content: center;
	align-items: center;
	-webkit-flex-direction: column;
	-moz-flex-direction: column;
	-ms-flex-direction: column;
	-o-flex-direction: column;
	flex-direction: column;
	margin-top: 0px;
	color: #36406B;
	fill: #36406B;
	height: 40px;
}
.tabActive {
	fill: #EEC03A;
	color: #EEC03A;
}
.icon>svg {

}
.icon>p {
	font-size: 13px;
	font-weight: 500;
}
#dockBar svg {
	width: 25px;
	margin: 0 10vw;
}
</style>


// WEBPACK FOOTER //
// src/Dock.vue